module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/diversification-icon-18c670864d477f05fa5bec31bb07b6a1.svg";